import React from 'react';

import { flagStyles } from '../settings';

const SvgPY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4416px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPY;
